module.exports = __webpack_public_path__ + "static/media/refresh.a6fae1e6.svg";